export enum TicketType {
  FactoryPrice = 'FactoryPrice',
}
